import { getApiBaseUrl } from "./axios";

export const getAttachmentUrl = (raceId: number, attachmentId: number) => {
    const baseUrl = getApiBaseUrl();
    return `${baseUrl}/races/${raceId}/attachments/${attachmentId}`;
};